// Generated from DslParser.g4 by ANTLR 4.13.1
package climat.lang

import com.strumenta.antlrkotlin.runtime.JsName
import org.antlr.v4.kotlinruntime.*
import org.antlr.v4.kotlinruntime.atn.*
import org.antlr.v4.kotlinruntime.atn.ATN.Companion.INVALID_ALT_NUMBER
import org.antlr.v4.kotlinruntime.dfa.*
import org.antlr.v4.kotlinruntime.misc.*
import org.antlr.v4.kotlinruntime.tree.*
import kotlin.jvm.JvmField

@Suppress(
    // This is required as we are using a custom JsName alias that is not recognized by the IDE.
    // No name clashes will happen tho.
    "JS_NAME_CLASH",
    "UNUSED_VARIABLE",
    "ClassName",
    "FunctionName",
    "LocalVariableName",
    "ConstPropertyName",
    "ConvertSecondaryConstructorToPrimary",
    "CanBeVal",
)
public open class DslParser(input: TokenStream) : Parser(input) {
    private companion object {
        init {
            RuntimeMetaData.checkVersion("4.13.1", RuntimeMetaData.runtimeVersion)
        }

        private const val SERIALIZED_ATN: String =
            "\u0004\u0001\u003b\u0123\u0002\u0000\u0007\u0000\u0002\u0001\u0007\u0001\u0002\u0002\u0007\u0002\u0002\u0003\u0007\u0003\u0002\u0004\u0007\u0004\u0002\u0005\u0007\u0005\u0002\u0006\u0007\u0006\u0002\u0007\u0007\u0007\u0002\u0008\u0007\u0008\u0002\u0009\u0007\u0009\u0002\u000a\u0007\u000a\u0002\u000b\u0007\u000b\u0002\u000c\u0007\u000c\u0002\u000d\u0007\u000d\u0002\u000e\u0007\u000e\u0002\u000f\u0007\u000f\u0002\u0010\u0007\u0010\u0002\u0011\u0007\u0011\u0002\u0012\u0007\u0012\u0002\u0013\u0007\u0013\u0002\u0014\u0007\u0014\u0002\u0015\u0007\u0015\u0002\u0016\u0007\u0016\u0002\u0017\u0007\u0017\u0002\u0018\u0007\u0018\u0002\u0019\u0007\u0019\u0002\u001a\u0007\u001a\u0002\u001b\u0007\u001b\u0002\u001c\u0007\u001c\u0002\u001d\u0007\u001d\u0002\u001e\u0007\u001e\u0002\u001f\u0007\u001f\u0002\u0020\u0007\u0020\u0001\u0000\u0003\u0000\u0044\u0008\u0000\u0001\u0000\u0005\u0000\u0047\u0008\u0000\u000a\u0000\u000c\u0000\u004a\u0009\u0000\u0001\u0000\u0001\u0000\u0001\u0000\u0003\u0000\u004f\u0008\u0000\u0001\u0000\u0003\u0000\u0052\u0008\u0000\u0001\u0000\u0001\u0000\u0001\u0000\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0001\u0003\u0001\u005b\u0008\u0001\u0001\u0002\u0001\u0002\u0005\u0002\u005f\u0008\u0002\u000a\u0002\u000c\u0002\u0062\u0009\u0002\u0001\u0002\u0001\u0002\u0001\u0003\u0001\u0003\u0001\u0003\u0003\u0003\u0069\u0008\u0003\u0001\u0004\u0003\u0004\u006c\u0008\u0004\u0001\u0004\u0005\u0004\u006f\u0008\u0004\u000a\u0004\u000c\u0004\u0072\u0009\u0004\u0001\u0004\u0001\u0004\u0001\u0004\u0001\u0004\u0003\u0004\u0078\u0008\u0004\u0001\u0004\u0003\u0004\u007b\u0008\u0004\u0001\u0004\u0001\u0004\u0001\u0005\u0001\u0005\u0003\u0005\u0081\u0008\u0005\u0001\u0006\u0001\u0006\u0001\u0006\u0001\u0006\u0001\u0006\u0001\u0007\u0001\u0007\u0001\u0007\u0004\u0007\u008b\u0008\u0007\u000b\u0007\u000c\u0007\u008c\u0001\u0007\u0001\u0007\u0001\u0008\u0001\u0008\u0001\u0008\u0005\u0008\u0094\u0008\u0008\u000a\u0008\u000c\u0008\u0097\u0009\u0008\u0001\u0008\u0003\u0008\u009a\u0008\u0008\u0001\u0009\u0001\u0009\u0003\u0009\u009e\u0008\u0009\u0001\u0009\u0001\u0009\u0001\u0009\u0001\u000a\u0001\u000a\u0003\u000a\u00a5\u0008\u000a\u0001\u000b\u0001\u000b\u0003\u000b\u00a9\u0008\u000b\u0001\u000b\u0001\u000b\u0003\u000b\u00ad\u0008\u000b\u0001\u000c\u0001\u000c\u0001\u000d\u0001\u000d\u0005\u000d\u00b3\u0008\u000d\u000a\u000d\u000c\u000d\u00b6\u0009\u000d\u0001\u000d\u0001\u000d\u0001\u000e\u0001\u000e\u0001\u000f\u0001\u000f\u0001\u000f\u0003\u000f\u00bf\u0008\u000f\u0001\u0010\u0001\u0010\u0005\u0010\u00c3\u0008\u0010\u000a\u0010\u000c\u0010\u00c6\u0009\u0010\u0001\u0010\u0001\u0010\u0001\u0011\u0001\u0011\u0005\u0011\u00cc\u0008\u0011\u000a\u0011\u000c\u0011\u00cf\u0009\u0011\u0001\u0011\u0001\u0011\u0001\u0012\u0001\u0012\u0001\u0012\u0001\u0012\u0001\u0012\u0001\u0013\u0001\u0013\u0003\u0013\u00da\u0008\u0013\u0001\u0014\u0001\u0014\u0001\u0015\u0001\u0015\u0005\u0015\u00e0\u0008\u0015\u000a\u0015\u000c\u0015\u00e3\u0009\u0015\u0001\u0015\u0001\u0015\u0001\u0016\u0001\u0016\u0003\u0016\u00e9\u0008\u0016\u0001\u0017\u0001\u0017\u0001\u0018\u0001\u0018\u0003\u0018\u00ef\u0008\u0018\u0001\u0018\u0001\u0018\u0003\u0018\u00f3\u0008\u0018\u0001\u0018\u0001\u0018\u0001\u0019\u0001\u0019\u0003\u0019\u00f9\u0008\u0019\u0001\u001a\u0001\u001a\u0001\u001b\u0001\u001b\u0003\u001b\u00ff\u0008\u001b\u0001\u001b\u0001\u001b\u0003\u001b\u0103\u0008\u001b\u0001\u001b\u0001\u001b\u0001\u001c\u0001\u001c\u0001\u001c\u0005\u001c\u010a\u0008\u001c\u000a\u001c\u000c\u001c\u010d\u0009\u001c\u0001\u001c\u0001\u001c\u0001\u001d\u0001\u001d\u0001\u001e\u0001\u001e\u0005\u001e\u0115\u0008\u001e\u000a\u001e\u000c\u001e\u0118\u0009\u001e\u0001\u001e\u0001\u001e\u0001\u001f\u0001\u001f\u0003\u001f\u011e\u0008\u001f\u0001\u0020\u0001\u0020\u0001\u0020\u0001\u0020\u0000\u0000\u0021\u0000\u0002\u0004\u0006\u0008\u000a\u000c\u000e\u0010\u0012\u0014\u0016\u0018\u001a\u001c\u001e\u0020\u0022\u0024\u0026\u0028\u002a\u002c\u002e\u0030\u0032\u0034\u0036\u0038\u003a\u003c\u003e\u0040\u0000\u0004\u0001\u0000\u000d\u000e\u0001\u0000\u0025\u0026\u0002\u0000\u0029\u0029\u002b\u002b\u0001\u0000\u0032\u0034\u0127\u0000\u0043\u0001\u0000\u0000\u0000\u0002\u005a\u0001\u0000\u0000\u0000\u0004\u005c\u0001\u0000\u0000\u0000\u0006\u0068\u0001\u0000\u0000\u0000\u0008\u006b\u0001\u0000\u0000\u0000\u000a\u0080\u0001\u0000\u0000\u0000\u000c\u0082\u0001\u0000\u0000\u0000\u000e\u0087\u0001\u0000\u0000\u0000\u0010\u0090\u0001\u0000\u0000\u0000\u0012\u009b\u0001\u0000\u0000\u0000\u0014\u00a4\u0001\u0000\u0000\u0000\u0016\u00a6\u0001\u0000\u0000\u0000\u0018\u00ae\u0001\u0000\u0000\u0000\u001a\u00b0\u0001\u0000\u0000\u0000\u001c\u00b9\u0001\u0000\u0000\u0000\u001e\u00be\u0001\u0000\u0000\u0000\u0020\u00c0\u0001\u0000\u0000\u0000\u0022\u00c9\u0001\u0000\u0000\u0000\u0024\u00d2\u0001\u0000\u0000\u0000\u0026\u00d9\u0001\u0000\u0000\u0000\u0028\u00db\u0001\u0000\u0000\u0000\u002a\u00dd\u0001\u0000\u0000\u0000\u002c\u00e8\u0001\u0000\u0000\u0000\u002e\u00ea\u0001\u0000\u0000\u0000\u0030\u00ec\u0001\u0000\u0000\u0000\u0032\u00f8\u0001\u0000\u0000\u0000\u0034\u00fa\u0001\u0000\u0000\u0000\u0036\u00fc\u0001\u0000\u0000\u0000\u0038\u0106\u0001\u0000\u0000\u0000\u003a\u0110\u0001\u0000\u0000\u0000\u003c\u0112\u0001\u0000\u0000\u0000\u003e\u011d\u0001\u0000\u0000\u0000\u0040\u011f\u0001\u0000\u0000\u0000\u0042\u0044\u0003\u003c\u001e\u0000\u0043\u0042\u0001\u0000\u0000\u0000\u0043\u0044\u0001\u0000\u0000\u0000\u0044\u0048\u0001\u0000\u0000\u0000\u0045\u0047\u0003\u0002\u0001\u0000\u0046\u0045\u0001\u0000\u0000\u0000\u0047\u004a\u0001\u0000\u0000\u0000\u0048\u0046\u0001\u0000\u0000\u0000\u0048\u0049\u0001\u0000\u0000\u0000\u0049\u004b\u0001\u0000\u0000\u0000\u004a\u0048\u0001\u0000\u0000\u0000\u004b\u0051\u0005\u0023\u0000\u0000\u004c\u004e\u0005\u0004\u0000\u0000\u004d\u004f\u0003\u0010\u0008\u0000\u004e\u004d\u0001\u0000\u0000\u0000\u004e\u004f\u0001\u0000\u0000\u0000\u004f\u0050\u0001\u0000\u0000\u0000\u0050\u0052\u0005\u0005\u0000\u0000\u0051\u004c\u0001\u0000\u0000\u0000\u0051\u0052\u0001\u0000\u0000\u0000\u0052\u0053\u0001\u0000\u0000\u0000\u0053\u0054\u0003\u0004\u0002\u0000\u0054\u0055\u0005\u0000\u0000\u0001\u0055\u0001\u0001\u0000\u0000\u0000\u0056\u005b\u0005\u0016\u0000\u0000\u0057\u005b\u0005\u001a\u0000\u0000\u0058\u005b\u0003\u000c\u0006\u0000\u0059\u005b\u0003\u000e\u0007\u0000\u005a\u0056\u0001\u0000\u0000\u0000\u005a\u0057\u0001\u0000\u0000\u0000\u005a\u0058\u0001\u0000\u0000\u0000\u005a\u0059\u0001\u0000\u0000\u0000\u005b\u0003\u0001\u0000\u0000\u0000\u005c\u0060\u0005\u0006\u0000\u0000\u005d\u005f\u0003\u0006\u0003\u0000\u005e\u005d\u0001\u0000\u0000\u0000\u005f\u0062\u0001\u0000\u0000\u0000\u0060\u005e\u0001\u0000\u0000\u0000\u0060\u0061\u0001\u0000\u0000\u0000\u0061\u0063\u0001\u0000\u0000\u0000\u0062\u0060\u0001\u0000\u0000\u0000\u0063\u0064\u0005\u0007\u0000\u0000\u0064\u0005\u0001\u0000\u0000\u0000\u0065\u0069\u0003\u0008\u0004\u0000\u0066\u0069\u0003\u001e\u000f\u0000\u0067\u0069\u0003\u0024\u0012\u0000\u0068\u0065\u0001\u0000\u0000\u0000\u0068\u0066\u0001\u0000\u0000\u0000\u0068\u0067\u0001\u0000\u0000\u0000\u0069\u0007\u0001\u0000\u0000\u0000\u006a\u006c\u0003\u003c\u001e\u0000\u006b\u006a\u0001\u0000\u0000\u0000\u006b\u006c\u0001\u0000\u0000\u0000\u006c\u0070\u0001\u0000\u0000\u0000\u006d\u006f\u0003\u000a\u0005\u0000\u006e\u006d\u0001\u0000\u0000\u0000\u006f\u0072\u0001\u0000\u0000\u0000\u0070\u006e\u0001\u0000\u0000\u0000\u0070\u0071\u0001\u0000\u0000\u0000\u0071\u0073\u0001\u0000\u0000\u0000\u0072\u0070\u0001\u0000\u0000\u0000\u0073\u0074\u0005\u001b\u0000\u0000\u0074\u007a\u0005\u0023\u0000\u0000\u0075\u0077\u0005\u0004\u0000\u0000\u0076\u0078\u0003\u0010\u0008\u0000\u0077\u0076\u0001\u0000\u0000\u0000\u0077\u0078\u0001\u0000\u0000\u0000\u0078\u0079\u0001\u0000\u0000\u0000\u0079\u007b\u0005\u0005\u0000\u0000\u007a\u0075\u0001\u0000\u0000\u0000\u007a\u007b\u0001\u0000\u0000\u0000\u007b\u007c\u0001\u0000\u0000\u0000\u007c\u007d\u0003\u001a\u000d\u0000\u007d\u0009\u0001\u0000\u0000\u0000\u007e\u0081\u0003\u0002\u0001\u0000\u007f\u0081\u0005\u0017\u0000\u0000\u0080\u007e\u0001\u0000\u0000\u0000\u0080\u007f\u0001\u0000\u0000\u0000\u0081\u000b\u0001\u0000\u0000\u0000\u0082\u0083\u0005\u0018\u0000\u0000\u0083\u0084\u0005\u0004\u0000\u0000\u0084\u0085\u0005\u0023\u0000\u0000\u0085\u0086\u0005\u0005\u0000\u0000\u0086\u000d\u0001\u0000\u0000\u0000\u0087\u0088\u0005\u0019\u0000\u0000\u0088\u008a\u0005\u0004\u0000\u0000\u0089\u008b\u0005\u0023\u0000\u0000\u008a\u0089\u0001\u0000\u0000\u0000\u008b\u008c\u0001\u0000\u0000\u0000\u008c\u008a\u0001\u0000\u0000\u0000\u008c\u008d\u0001\u0000\u0000\u0000\u008d\u008e\u0001\u0000\u0000\u0000\u008e\u008f\u0005\u0005\u0000\u0000\u008f\u000f\u0001\u0000\u0000\u0000\u0090\u0095\u0003\u0012\u0009\u0000\u0091\u0092\u0005\u0002\u0000\u0000\u0092\u0094\u0003\u0012\u0009\u0000\u0093\u0091\u0001\u0000\u0000\u0000\u0094\u0097\u0001\u0000\u0000\u0000\u0095\u0093\u0001\u0000\u0000\u0000\u0095\u0096\u0001\u0000\u0000\u0000\u0096\u0099\u0001\u0000\u0000\u0000\u0097\u0095\u0001\u0000\u0000\u0000\u0098\u009a\u0005\u0002\u0000\u0000\u0099\u0098\u0001\u0000\u0000\u0000\u0099\u009a\u0001\u0000\u0000\u0000\u009a\u0011\u0001\u0000\u0000\u0000\u009b\u009d\u0005\u0023\u0000\u0000\u009c\u009e\u0003\u0018\u000c\u0000\u009d\u009c\u0001\u0000\u0000\u0000\u009d\u009e\u0001\u0000\u0000\u0000\u009e\u009f\u0001\u0000\u0000\u0000\u009f\u00a0\u0005\u0003\u0000\u0000\u00a0\u00a1\u0003\u0014\u000a\u0000\u00a1\u0013\u0001\u0000\u0000\u0000\u00a2\u00a5\u0005\u0012\u0000\u0000\u00a3\u00a5\u0003\u0016\u000b\u0000\u00a4\u00a2\u0001\u0000\u0000\u0000\u00a4\u00a3\u0001\u0000\u0000\u0000\u00a5\u0015\u0001\u0000\u0000\u0000\u00a6\u00a8\u0005\u0013\u0000\u0000\u00a7\u00a9\u0005\u000b\u0000\u0000\u00a8\u00a7\u0001\u0000\u0000\u0000\u00a8\u00a9\u0001\u0000\u0000\u0000\u00a9\u00ac\u0001\u0000\u0000\u0000\u00aa\u00ab\u0005\u0001\u0000\u0000\u00ab\u00ad\u0003\u0026\u0013\u0000\u00ac\u00aa\u0001\u0000\u0000\u0000\u00ac\u00ad\u0001\u0000\u0000\u0000\u00ad\u0017\u0001\u0000\u0000\u0000\u00ae\u00af\u0005\u0023\u0000\u0000\u00af\u0019\u0001\u0000\u0000\u0000\u00b0\u00b4\u0005\u0006\u0000\u0000\u00b1\u00b3\u0003\u001c\u000e\u0000\u00b2\u00b1\u0001\u0000\u0000\u0000\u00b3\u00b6\u0001\u0000\u0000\u0000\u00b4\u00b2\u0001\u0000\u0000\u0000\u00b4\u00b5\u0001\u0000\u0000\u0000\u00b5\u00b7\u0001\u0000\u0000\u0000\u00b6\u00b4\u0001\u0000\u0000\u0000\u00b7\u00b8\u0005\u0007\u0000\u0000\u00b8\u001b\u0001\u0000\u0000\u0000\u00b9\u00ba\u0003\u0006\u0003\u0000\u00ba\u001d\u0001\u0000\u0000\u0000\u00bb\u00bf\u0003\u0020\u0010\u0000\u00bc\u00bf\u0003\u0022\u0011\u0000\u00bd\u00bf\u0005\u0020\u0000\u0000\u00be\u00bb\u0001\u0000\u0000\u0000\u00be\u00bc\u0001\u0000\u0000\u0000\u00be\u00bd\u0001\u0000\u0000\u0000\u00bf\u001f\u0001\u0000\u0000\u0000\u00c0\u00c4\u0005\u001c\u0000\u0000\u00c1\u00c3\u0003\u0032\u0019\u0000\u00c2\u00c1\u0001\u0000\u0000\u0000\u00c3\u00c6\u0001\u0000\u0000\u0000\u00c4\u00c2\u0001\u0000\u0000\u0000\u00c4\u00c5\u0001\u0000\u0000\u0000\u00c5\u00c7\u0001\u0000\u0000\u0000\u00c6\u00c4\u0001\u0000\u0000\u0000\u00c7\u00c8\u0005\u002a\u0000\u0000\u00c8\u0021\u0001\u0000\u0000\u0000\u00c9\u00cd\u0005\u001d\u0000\u0000\u00ca\u00cc\u0005\u003b\u0000\u0000\u00cb\u00ca\u0001\u0000\u0000\u0000\u00cc\u00cf\u0001\u0000\u0000\u0000\u00cd\u00cb\u0001\u0000\u0000\u0000\u00cd\u00ce\u0001\u0000\u0000\u0000\u00ce\u00d0\u0001\u0000\u0000\u0000\u00cf\u00cd\u0001\u0000\u0000\u0000\u00d0\u00d1\u0005\u003a\u0000\u0000\u00d1\u0023\u0001\u0000\u0000\u0000\u00d2\u00d3\u0005\u000c\u0000\u0000\u00d3\u00d4\u0005\u0023\u0000\u0000\u00d4\u00d5\u0005\u0001\u0000\u0000\u00d5\u00d6\u0003\u0026\u0013\u0000\u00d6\u0025\u0001\u0000\u0000\u0000\u00d7\u00da\u0003\u002a\u0015\u0000\u00d8\u00da\u0003\u0028\u0014\u0000\u00d9\u00d7\u0001\u0000\u0000\u0000\u00d9\u00d8\u0001\u0000\u0000\u0000\u00da\u0027\u0001\u0000\u0000\u0000\u00db\u00dc\u0007\u0000\u0000\u0000\u00dc\u0029\u0001\u0000\u0000\u0000\u00dd\u00e1\u0005\u000a\u0000\u0000\u00de\u00e0\u0003\u002c\u0016\u0000\u00df\u00de\u0001\u0000\u0000\u0000\u00e0\u00e3\u0001\u0000\u0000\u0000\u00e1\u00df\u0001\u0000\u0000\u0000\u00e1\u00e2\u0001\u0000\u0000\u0000\u00e2\u00e4\u0001\u0000\u0000\u0000\u00e3\u00e1\u0001\u0000\u0000\u0000\u00e4\u00e5\u0005\u0027\u0000\u0000\u00e5\u002b\u0001\u0000\u0000\u0000\u00e6\u00e9\u0003\u002e\u0017\u0000\u00e7\u00e9\u0003\u0030\u0018\u0000\u00e8\u00e6\u0001\u0000\u0000\u0000\u00e8\u00e7\u0001\u0000\u0000\u0000\u00e9\u002d\u0001\u0000\u0000\u0000\u00ea\u00eb\u0007\u0001\u0000\u0000\u00eb\u002f\u0001\u0000\u0000\u0000\u00ec\u00ee\u0005\u0024\u0000\u0000\u00ed\u00ef\u0005\u0031\u0000\u0000\u00ee\u00ed\u0001\u0000\u0000\u0000\u00ee\u00ef\u0001\u0000\u0000\u0000\u00ef\u00f0\u0001\u0000\u0000\u0000\u00f0\u00f2\u0005\u002c\u0000\u0000\u00f1\u00f3\u0003\u0038\u001c\u0000\u00f2\u00f1\u0001\u0000\u0000\u0000\u00f2\u00f3\u0001\u0000\u0000\u0000\u00f3\u00f4\u0001\u0000\u0000\u0000\u00f4\u00f5\u0005\u002f\u0000\u0000\u00f5\u0031\u0001\u0000\u0000\u0000\u00f6\u00f9\u0003\u0034\u001a\u0000\u00f7\u00f9\u0003\u0036\u001b\u0000\u00f8\u00f6\u0001\u0000\u0000\u0000\u00f8\u00f7\u0001\u0000\u0000\u0000\u00f9\u0033\u0001\u0000\u0000\u0000\u00fa\u00fb\u0007\u0002\u0000\u0000\u00fb\u0035\u0001\u0000\u0000\u0000\u00fc\u00fe\u0005\u0028\u0000\u0000\u00fd\u00ff\u0005\u0031\u0000\u0000\u00fe\u00fd\u0001\u0000\u0000\u0000\u00fe\u00ff\u0001\u0000\u0000\u0000\u00ff\u0100\u0001\u0000\u0000\u0000\u0100\u0102\u0005\u002c\u0000\u0000\u0101\u0103\u0003\u0038\u001c\u0000\u0102\u0101\u0001\u0000\u0000\u0000\u0102\u0103\u0001\u0000\u0000\u0000\u0103\u0104\u0001\u0000\u0000\u0000\u0104\u0105\u0005\u002f\u0000\u0000\u0105\u0037\u0001\u0000\u0000\u0000\u0106\u0107\u0005\u002d\u0000\u0000\u0107\u010b\u0005\u002e\u0000\u0000\u0108\u010a\u0003\u003a\u001d\u0000\u0109\u0108\u0001\u0000\u0000\u0000\u010a\u010d\u0001\u0000\u0000\u0000\u010b\u0109\u0001\u0000\u0000\u0000\u010b\u010c\u0001\u0000\u0000\u0000\u010c\u010e\u0001\u0000\u0000\u0000\u010d\u010b\u0001\u0000\u0000\u0000\u010e\u010f\u0005\u0035\u0000\u0000\u010f\u0039\u0001\u0000\u0000\u0000\u0110\u0111\u0007\u0003\u0000\u0000\u0111\u003b\u0001\u0000\u0000\u0000\u0112\u0116\u0005\u0021\u0000\u0000\u0113\u0115\u0003\u003e\u001f\u0000\u0114\u0113\u0001\u0000\u0000\u0000\u0115\u0118\u0001\u0000\u0000\u0000\u0116\u0114\u0001\u0000\u0000\u0000\u0116\u0117\u0001\u0000\u0000\u0000\u0117\u0119\u0001\u0000\u0000\u0000\u0118\u0116\u0001\u0000\u0000\u0000\u0119\u011a\u0005\u0038\u0000\u0000\u011a\u003d\u0001\u0000\u0000\u0000\u011b\u011e\u0005\u0037\u0000\u0000\u011c\u011e\u0003\u0040\u0020\u0000\u011d\u011b\u0001\u0000\u0000\u0000\u011d\u011c\u0001\u0000\u0000\u0000\u011e\u003f\u0001\u0000\u0000\u0000\u011f\u0120\u0005\u0036\u0000\u0000\u0120\u0121\u0005\u0039\u0000\u0000\u0121\u0041\u0001\u0000\u0000\u0000\u0022\u0043\u0048\u004e\u0051\u005a\u0060\u0068\u006b\u0070\u0077\u007a\u0080\u008c\u0095\u0099\u009d\u00a4\u00a8\u00ac\u00b4\u00be\u00c4\u00cd\u00d9\u00e1\u00e8\u00ee\u00f2\u00f8\u00fe\u0102\u010b\u0116\u011d"

        private val ATN = ATNDeserializer().deserialize(SERIALIZED_ATN.toCharArray())

        private val DECISION_TO_DFA = Array(ATN.numberOfDecisions) {
            DFA(ATN.getDecisionState(it)!!, it)
        }

        private val SHARED_CONTEXT_CACHE = PredictionContextCache()
        private val RULE_NAMES: Array<String> = arrayOf(
            "root", "rootModifiers", "rootBody", "rootStatements", "sub", 
            "subModifiers", "aliasModifier", "aliasesModifier", "params", 
            "param", "paramType", "argument", "paramShort", "subBody", "subStatements", 
            "action", "shellAction", "javascriptAction", "constDef", "literal", 
            "booleanLiteral", "stringTemplate", "stringTemplateEntry", "stringTemplateContent", 
            "stringTemplateInterpolation", "actionTemplateEntry", "actionTemplateContent", 
            "actionTemplateInterpolation", "mapping", "mappingTemplateEntry", 
            "docstring", "docstringEntry", "paramTag"
        )

        private val LITERAL_NAMES: Array<String?> = arrayOf(
            null, "'='", "','", "':'", "'('", "')'", "'{'", "'}'", "'['", 
            "']'", null, "'?'", "'const'", "'true'", "'false'", "'act'", 
            "'sh'", "'js'", "'flag'", "'arg'", "'override'", "'default'", 
            "'@seal'", "'@shift'", "'@alias'", "'@aliases'", "'@allow-unmatched'", 
            "'sub'", null, null, null, null, null, null, null, null, null, 
            null, null, null, null, null, null, null, null, null, null, 
            null, null, "'!'"
        )

        private val SYMBOLIC_NAMES: Array<String?> = arrayOf(
            null, "EQ", "COMMA", "COLON", "LPAREN", "RPAREN", "LCURLY", 
            "RCURLY", "LBRAKET", "RBRAKET", "DOUBLE_QUOTE", "QMARK", "CONST", 
            "TRUE", "FALSE", "ACT", "SH", "JS", "FLAG", "ARGUMENT", "OVERRIDE", 
            "DEFAULT", "MOD_SEAL", "MOD_SHIFT", "MOD_ALIAS", "MOD_ALIASES", 
            "MOD_ALLOW_UNMATCHED", "SUB", "ActionTemplate_BEGIN", "CustomScript_JS_BEGIN", 
            "MULTILINE_COMMENT", "SINGLELINE_COMMENT", "ACT_SCOPE_PARAMS", 
            "Docstring_BEGIN", "WS", "IDENTIFIER", "StringTemplate_Interpolation_OPEN", 
            "StringTemplate_AT", "StringTemplate_CONTENT", "StringTemplate_CLOSE", 
            "ActionTemplate_Interpolation_OPEN", "ActionTemplate_AT", "ActionTemplate_CLOSE", 
            "ActionTemplate_CONTENT", "Interpolation_IDENTIFIER", "Interpolation_QMARK", 
            "Interpolation_MAPPING_OPEN", "Interpolation_CLOSE", "Interpolation_WS", 
            "Interpolation_NEGATE", "MappingTemplate_PLACEHOLDER", "MappingTemplate_CONTENT", 
            "MappingTemplate_LCURLY", "MappingTemplate_CLOSE", "Docstring_AT_PARAM", 
            "Docstring_CONTENT", "Docstring_END", "Docstring_IDENTIFIER", 
            "CustomScript_END", "CustomScript_SCRIPT"
        )

        private val VOCABULARY = VocabularyImpl(LITERAL_NAMES, SYMBOLIC_NAMES)

        private val TOKEN_NAMES: Array<String> = Array(SYMBOLIC_NAMES.size) {
            VOCABULARY.getLiteralName(it)
                ?: VOCABULARY.getSymbolicName(it)
                ?: "<INVALID>"
        }
    }

    public object Tokens {
        public const val EOF: Int = -1
        public const val EQ: Int = 1
        public const val COMMA: Int = 2
        public const val COLON: Int = 3
        public const val LPAREN: Int = 4
        public const val RPAREN: Int = 5
        public const val LCURLY: Int = 6
        public const val RCURLY: Int = 7
        public const val LBRAKET: Int = 8
        public const val RBRAKET: Int = 9
        public const val DOUBLE_QUOTE: Int = 10
        public const val QMARK: Int = 11
        public const val CONST: Int = 12
        public const val TRUE: Int = 13
        public const val FALSE: Int = 14
        public const val ACT: Int = 15
        public const val SH: Int = 16
        public const val JS: Int = 17
        public const val FLAG: Int = 18
        public const val ARGUMENT: Int = 19
        public const val OVERRIDE: Int = 20
        public const val DEFAULT: Int = 21
        public const val MOD_SEAL: Int = 22
        public const val MOD_SHIFT: Int = 23
        public const val MOD_ALIAS: Int = 24
        public const val MOD_ALIASES: Int = 25
        public const val MOD_ALLOW_UNMATCHED: Int = 26
        public const val SUB: Int = 27
        public const val ActionTemplate_BEGIN: Int = 28
        public const val CustomScript_JS_BEGIN: Int = 29
        public const val MULTILINE_COMMENT: Int = 30
        public const val SINGLELINE_COMMENT: Int = 31
        public const val ACT_SCOPE_PARAMS: Int = 32
        public const val Docstring_BEGIN: Int = 33
        public const val WS: Int = 34
        public const val IDENTIFIER: Int = 35
        public const val StringTemplate_Interpolation_OPEN: Int = 36
        public const val StringTemplate_AT: Int = 37
        public const val StringTemplate_CONTENT: Int = 38
        public const val StringTemplate_CLOSE: Int = 39
        public const val ActionTemplate_Interpolation_OPEN: Int = 40
        public const val ActionTemplate_AT: Int = 41
        public const val ActionTemplate_CLOSE: Int = 42
        public const val ActionTemplate_CONTENT: Int = 43
        public const val Interpolation_IDENTIFIER: Int = 44
        public const val Interpolation_QMARK: Int = 45
        public const val Interpolation_MAPPING_OPEN: Int = 46
        public const val Interpolation_CLOSE: Int = 47
        public const val Interpolation_WS: Int = 48
        public const val Interpolation_NEGATE: Int = 49
        public const val MappingTemplate_PLACEHOLDER: Int = 50
        public const val MappingTemplate_CONTENT: Int = 51
        public const val MappingTemplate_LCURLY: Int = 52
        public const val MappingTemplate_CLOSE: Int = 53
        public const val Docstring_AT_PARAM: Int = 54
        public const val Docstring_CONTENT: Int = 55
        public const val Docstring_END: Int = 56
        public const val Docstring_IDENTIFIER: Int = 57
        public const val CustomScript_END: Int = 58
        public const val CustomScript_SCRIPT: Int = 59
    }

    public object Rules {
        public const val Root: Int = 0
        public const val RootModifiers: Int = 1
        public const val RootBody: Int = 2
        public const val RootStatements: Int = 3
        public const val Sub: Int = 4
        public const val SubModifiers: Int = 5
        public const val AliasModifier: Int = 6
        public const val AliasesModifier: Int = 7
        public const val Params: Int = 8
        public const val Param: Int = 9
        public const val ParamType: Int = 10
        public const val Argument: Int = 11
        public const val ParamShort: Int = 12
        public const val SubBody: Int = 13
        public const val SubStatements: Int = 14
        public const val Action: Int = 15
        public const val ShellAction: Int = 16
        public const val JavascriptAction: Int = 17
        public const val ConstDef: Int = 18
        public const val Literal: Int = 19
        public const val BooleanLiteral: Int = 20
        public const val StringTemplate: Int = 21
        public const val StringTemplateEntry: Int = 22
        public const val StringTemplateContent: Int = 23
        public const val StringTemplateInterpolation: Int = 24
        public const val ActionTemplateEntry: Int = 25
        public const val ActionTemplateContent: Int = 26
        public const val ActionTemplateInterpolation: Int = 27
        public const val Mapping: Int = 28
        public const val MappingTemplateEntry: Int = 29
        public const val Docstring: Int = 30
        public const val DocstringEntry: Int = 31
        public const val ParamTag: Int = 32
    }

    override var interpreter: ParserATNSimulator =
        @Suppress("LeakingThis")
        ParserATNSimulator(this, ATN, DECISION_TO_DFA, SHARED_CONTEXT_CACHE)

    override val grammarFileName: String =
        "DslParser.g4"

    @Deprecated("Use vocabulary instead", replaceWith = ReplaceWith("vocabulary"))
    override val tokenNames: Array<String> =
        TOKEN_NAMES

    override val ruleNames: Array<String> =
        RULE_NAMES

    override val atn: ATN =
        ATN

    override val vocabulary: Vocabulary =
        VOCABULARY

    override val serializedATN: String =
        SERIALIZED_ATN

    /* Named actions */

    /* Funcs */
    public open class RootContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.Root

        public fun IDENTIFIER(): TerminalNode = getToken(Tokens.IDENTIFIER, 0)!!
        public fun rootBody(): RootBodyContext = getRuleContext(RootBodyContext::class, 0)!!
        public fun EOF(): TerminalNode = getToken(Tokens.EOF, 0)!!
        public fun docstring(): DocstringContext? = getRuleContext(DocstringContext::class, 0)
        public fun rootModifiers(): List<RootModifiersContext> = getRuleContexts(RootModifiersContext::class)
        public fun rootModifiers(i: Int): RootModifiersContext? = getRuleContext(RootModifiersContext::class, i)
        public fun LPAREN(): TerminalNode? = getToken(Tokens.LPAREN, 0)
        public fun RPAREN(): TerminalNode? = getToken(Tokens.RPAREN, 0)
        public fun params(): ParamsContext? = getRuleContext(ParamsContext::class, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun root(): RootContext {
        var _localctx = RootContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 0, Rules.Root)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 67
            errorHandler.sync(this)
            _la = _input.LA(1)

            if (_la == Tokens.Docstring_BEGIN) {
                this.state = 66
                docstring()

            }
            this.state = 72
            errorHandler.sync(this)
            _la = _input.LA(1)

            while ((((_la) and 0x3f.inv()) == 0 && ((1L shl _la) and 121634816L) != 0L)) {
                this.state = 69
                rootModifiers()

                this.state = 74
                errorHandler.sync(this)
                _la = _input.LA(1)
            }
            this.state = 75
            match(Tokens.IDENTIFIER)

            this.state = 81
            errorHandler.sync(this)
            _la = _input.LA(1)

            if (_la == Tokens.LPAREN) {
                this.state = 76
                match(Tokens.LPAREN)

                this.state = 78
                errorHandler.sync(this)
                _la = _input.LA(1)

                if (_la == Tokens.IDENTIFIER) {
                    this.state = 77
                    params()

                }
                this.state = 80
                match(Tokens.RPAREN)

            }
            this.state = 83
            rootBody()

            this.state = 84
            match(Tokens.EOF)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class RootModifiersContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.RootModifiers

        public fun MOD_SEAL(): TerminalNode? = getToken(Tokens.MOD_SEAL, 0)
        public fun MOD_ALLOW_UNMATCHED(): TerminalNode? = getToken(Tokens.MOD_ALLOW_UNMATCHED, 0)
        public fun aliasModifier(): AliasModifierContext? = getRuleContext(AliasModifierContext::class, 0)
        public fun aliasesModifier(): AliasesModifierContext? = getRuleContext(AliasesModifierContext::class, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun rootModifiers(): RootModifiersContext {
        var _localctx = RootModifiersContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 2, Rules.RootModifiers)

        try {
            this.state = 90
            errorHandler.sync(this)

            when (_input.LA(1)) {
                Tokens.MOD_SEAL -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 1)
                    this.state = 86
                    match(Tokens.MOD_SEAL)

                }Tokens.MOD_ALLOW_UNMATCHED -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 2)
                    this.state = 87
                    match(Tokens.MOD_ALLOW_UNMATCHED)

                }Tokens.MOD_ALIAS -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 3)
                    this.state = 88
                    aliasModifier()

                }Tokens.MOD_ALIASES -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 4)
                    this.state = 89
                    aliasesModifier()

                }
                else -> throw NoViableAltException(this)
            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class RootBodyContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.RootBody

        public fun LCURLY(): TerminalNode = getToken(Tokens.LCURLY, 0)!!
        public fun RCURLY(): TerminalNode = getToken(Tokens.RCURLY, 0)!!
        public fun rootStatements(): List<RootStatementsContext> = getRuleContexts(RootStatementsContext::class)
        public fun rootStatements(i: Int): RootStatementsContext? = getRuleContext(RootStatementsContext::class, i)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun rootBody(): RootBodyContext {
        var _localctx = RootBodyContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 4, Rules.RootBody)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 92
            match(Tokens.LCURLY)

            this.state = 96
            errorHandler.sync(this)
            _la = _input.LA(1)

            while ((((_la) and 0x3f.inv()) == 0 && ((1L shl _la) and 13954453504L) != 0L)) {
                this.state = 93
                rootStatements()

                this.state = 98
                errorHandler.sync(this)
                _la = _input.LA(1)
            }
            this.state = 99
            match(Tokens.RCURLY)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class RootStatementsContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.RootStatements

        public fun sub(): SubContext? = getRuleContext(SubContext::class, 0)
        public fun action(): ActionContext? = getRuleContext(ActionContext::class, 0)
        public fun constDef(): ConstDefContext? = getRuleContext(ConstDefContext::class, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun rootStatements(): RootStatementsContext {
        var _localctx = RootStatementsContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 6, Rules.RootStatements)

        try {
            this.state = 104
            errorHandler.sync(this)

            when (_input.LA(1)) {
                Tokens.MOD_SEAL, Tokens.MOD_SHIFT, Tokens.MOD_ALIAS, Tokens.MOD_ALIASES, Tokens.MOD_ALLOW_UNMATCHED, Tokens.SUB, Tokens.Docstring_BEGIN -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 1)
                    this.state = 101
                    sub()

                }Tokens.ActionTemplate_BEGIN, Tokens.CustomScript_JS_BEGIN, Tokens.ACT_SCOPE_PARAMS -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 2)
                    this.state = 102
                    action()

                }Tokens.CONST -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 3)
                    this.state = 103
                    constDef()

                }
                else -> throw NoViableAltException(this)
            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class SubContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.Sub

        public fun SUB(): TerminalNode = getToken(Tokens.SUB, 0)!!
        public fun IDENTIFIER(): TerminalNode = getToken(Tokens.IDENTIFIER, 0)!!
        public fun subBody(): SubBodyContext = getRuleContext(SubBodyContext::class, 0)!!
        public fun docstring(): DocstringContext? = getRuleContext(DocstringContext::class, 0)
        public fun subModifiers(): List<SubModifiersContext> = getRuleContexts(SubModifiersContext::class)
        public fun subModifiers(i: Int): SubModifiersContext? = getRuleContext(SubModifiersContext::class, i)
        public fun LPAREN(): TerminalNode? = getToken(Tokens.LPAREN, 0)
        public fun RPAREN(): TerminalNode? = getToken(Tokens.RPAREN, 0)
        public fun params(): ParamsContext? = getRuleContext(ParamsContext::class, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun sub(): SubContext {
        var _localctx = SubContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 8, Rules.Sub)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 107
            errorHandler.sync(this)
            _la = _input.LA(1)

            if (_la == Tokens.Docstring_BEGIN) {
                this.state = 106
                docstring()

            }
            this.state = 112
            errorHandler.sync(this)
            _la = _input.LA(1)

            while ((((_la) and 0x3f.inv()) == 0 && ((1L shl _la) and 130023424L) != 0L)) {
                this.state = 109
                subModifiers()

                this.state = 114
                errorHandler.sync(this)
                _la = _input.LA(1)
            }
            this.state = 115
            match(Tokens.SUB)

            this.state = 116
            match(Tokens.IDENTIFIER)

            this.state = 122
            errorHandler.sync(this)
            _la = _input.LA(1)

            if (_la == Tokens.LPAREN) {
                this.state = 117
                match(Tokens.LPAREN)

                this.state = 119
                errorHandler.sync(this)
                _la = _input.LA(1)

                if (_la == Tokens.IDENTIFIER) {
                    this.state = 118
                    params()

                }
                this.state = 121
                match(Tokens.RPAREN)

            }
            this.state = 124
            subBody()

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class SubModifiersContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.SubModifiers

        public fun rootModifiers(): RootModifiersContext? = getRuleContext(RootModifiersContext::class, 0)
        public fun MOD_SHIFT(): TerminalNode? = getToken(Tokens.MOD_SHIFT, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun subModifiers(): SubModifiersContext {
        var _localctx = SubModifiersContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 10, Rules.SubModifiers)

        try {
            this.state = 128
            errorHandler.sync(this)

            when (_input.LA(1)) {
                Tokens.MOD_SEAL, Tokens.MOD_ALIAS, Tokens.MOD_ALIASES, Tokens.MOD_ALLOW_UNMATCHED -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 1)
                    this.state = 126
                    rootModifiers()

                }Tokens.MOD_SHIFT -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 2)
                    this.state = 127
                    match(Tokens.MOD_SHIFT)

                }
                else -> throw NoViableAltException(this)
            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class AliasModifierContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.AliasModifier

        public fun MOD_ALIAS(): TerminalNode = getToken(Tokens.MOD_ALIAS, 0)!!
        public fun LPAREN(): TerminalNode = getToken(Tokens.LPAREN, 0)!!
        public fun IDENTIFIER(): TerminalNode = getToken(Tokens.IDENTIFIER, 0)!!
        public fun RPAREN(): TerminalNode = getToken(Tokens.RPAREN, 0)!!

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun aliasModifier(): AliasModifierContext {
        var _localctx = AliasModifierContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 12, Rules.AliasModifier)

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 130
            match(Tokens.MOD_ALIAS)

            this.state = 131
            match(Tokens.LPAREN)

            this.state = 132
            match(Tokens.IDENTIFIER)

            this.state = 133
            match(Tokens.RPAREN)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class AliasesModifierContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.AliasesModifier

        public fun MOD_ALIASES(): TerminalNode = getToken(Tokens.MOD_ALIASES, 0)!!
        public fun LPAREN(): TerminalNode = getToken(Tokens.LPAREN, 0)!!
        public fun RPAREN(): TerminalNode = getToken(Tokens.RPAREN, 0)!!
        public fun IDENTIFIER(): List<TerminalNode> = getTokens(Tokens.IDENTIFIER)
        public fun IDENTIFIER(i: Int): TerminalNode? = getToken(Tokens.IDENTIFIER, i)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun aliasesModifier(): AliasesModifierContext {
        var _localctx = AliasesModifierContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 14, Rules.AliasesModifier)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 135
            match(Tokens.MOD_ALIASES)

            this.state = 136
            match(Tokens.LPAREN)

            this.state = 138 
            errorHandler.sync(this)
            _la = _input.LA(1)

            do {
                this.state = 137
                match(Tokens.IDENTIFIER)

                this.state = 140 
                errorHandler.sync(this)
                _la = _input.LA(1)
            } while (_la == Tokens.IDENTIFIER)
            this.state = 142
            match(Tokens.RPAREN)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class ParamsContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.Params

        public fun param(): List<ParamContext> = getRuleContexts(ParamContext::class)
        public fun param(i: Int): ParamContext? = getRuleContext(ParamContext::class, i)
        public fun COMMA(): List<TerminalNode> = getTokens(Tokens.COMMA)
        public fun COMMA(i: Int): TerminalNode? = getToken(Tokens.COMMA, i)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun params(): ParamsContext {
        var _localctx = ParamsContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 16, Rules.Params)
        var _la: Int

        try {
            var _alt: Int
            enterOuterAlt(_localctx, 1)
            this.state = 144
            param()

            this.state = 149
            errorHandler.sync(this)
            _alt = interpreter.adaptivePredict(_input, 13, context)

            while (_alt != 2 && _alt != INVALID_ALT_NUMBER) {
                if (_alt == 1 ) {
                    this.state = 145
                    match(Tokens.COMMA)

                    this.state = 146
                    param()
             
                }

                this.state = 151
                errorHandler.sync(this)
                _alt = interpreter.adaptivePredict(_input, 13, context)
            }
            this.state = 153
            errorHandler.sync(this)
            _la = _input.LA(1)

            if (_la == Tokens.COMMA) {
                this.state = 152
                match(Tokens.COMMA)

            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class ParamContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.Param

        public fun IDENTIFIER(): TerminalNode = getToken(Tokens.IDENTIFIER, 0)!!
        public fun COLON(): TerminalNode = getToken(Tokens.COLON, 0)!!
        public fun paramType(): ParamTypeContext = getRuleContext(ParamTypeContext::class, 0)!!
        public fun paramShort(): ParamShortContext? = getRuleContext(ParamShortContext::class, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun param(): ParamContext {
        var _localctx = ParamContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 18, Rules.Param)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 155
            match(Tokens.IDENTIFIER)

            this.state = 157
            errorHandler.sync(this)
            _la = _input.LA(1)

            if (_la == Tokens.IDENTIFIER) {
                this.state = 156
                paramShort()

            }
            this.state = 159
            match(Tokens.COLON)

            this.state = 160
            paramType()

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class ParamTypeContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.ParamType

        public fun FLAG(): TerminalNode? = getToken(Tokens.FLAG, 0)
        public fun argument(): ArgumentContext? = getRuleContext(ArgumentContext::class, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun paramType(): ParamTypeContext {
        var _localctx = ParamTypeContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 20, Rules.ParamType)

        try {
            this.state = 164
            errorHandler.sync(this)

            when (_input.LA(1)) {
                Tokens.FLAG -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 1)
                    this.state = 162
                    match(Tokens.FLAG)

                }Tokens.ARGUMENT -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 2)
                    this.state = 163
                    argument()

                }
                else -> throw NoViableAltException(this)
            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class ArgumentContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.Argument

        public fun ARGUMENT(): TerminalNode = getToken(Tokens.ARGUMENT, 0)!!
        public fun QMARK(): TerminalNode? = getToken(Tokens.QMARK, 0)
        public fun EQ(): TerminalNode? = getToken(Tokens.EQ, 0)
        public fun literal(): LiteralContext? = getRuleContext(LiteralContext::class, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun argument(): ArgumentContext {
        var _localctx = ArgumentContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 22, Rules.Argument)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 166
            match(Tokens.ARGUMENT)

            this.state = 168
            errorHandler.sync(this)
            _la = _input.LA(1)

            if (_la == Tokens.QMARK) {
                this.state = 167
                match(Tokens.QMARK)

            }
            this.state = 172
            errorHandler.sync(this)
            _la = _input.LA(1)

            if (_la == Tokens.EQ) {
                this.state = 170
                match(Tokens.EQ)

                this.state = 171
                literal()

            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class ParamShortContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.ParamShort

        public fun IDENTIFIER(): TerminalNode = getToken(Tokens.IDENTIFIER, 0)!!

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun paramShort(): ParamShortContext {
        var _localctx = ParamShortContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 24, Rules.ParamShort)

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 174
            match(Tokens.IDENTIFIER)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class SubBodyContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.SubBody

        public fun LCURLY(): TerminalNode = getToken(Tokens.LCURLY, 0)!!
        public fun RCURLY(): TerminalNode = getToken(Tokens.RCURLY, 0)!!
        public fun subStatements(): List<SubStatementsContext> = getRuleContexts(SubStatementsContext::class)
        public fun subStatements(i: Int): SubStatementsContext? = getRuleContext(SubStatementsContext::class, i)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun subBody(): SubBodyContext {
        var _localctx = SubBodyContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 26, Rules.SubBody)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 176
            match(Tokens.LCURLY)

            this.state = 180
            errorHandler.sync(this)
            _la = _input.LA(1)

            while ((((_la) and 0x3f.inv()) == 0 && ((1L shl _la) and 13954453504L) != 0L)) {
                this.state = 177
                subStatements()

                this.state = 182
                errorHandler.sync(this)
                _la = _input.LA(1)
            }
            this.state = 183
            match(Tokens.RCURLY)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class SubStatementsContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.SubStatements

        public fun rootStatements(): RootStatementsContext = getRuleContext(RootStatementsContext::class, 0)!!

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun subStatements(): SubStatementsContext {
        var _localctx = SubStatementsContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 28, Rules.SubStatements)

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 185
            rootStatements()

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class ActionContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.Action

        public fun shellAction(): ShellActionContext? = getRuleContext(ShellActionContext::class, 0)
        public fun javascriptAction(): JavascriptActionContext? = getRuleContext(JavascriptActionContext::class, 0)
        public fun ACT_SCOPE_PARAMS(): TerminalNode? = getToken(Tokens.ACT_SCOPE_PARAMS, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun action(): ActionContext {
        var _localctx = ActionContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 30, Rules.Action)

        try {
            this.state = 190
            errorHandler.sync(this)

            when (_input.LA(1)) {
                Tokens.ActionTemplate_BEGIN -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 1)
                    this.state = 187
                    shellAction()

                }Tokens.CustomScript_JS_BEGIN -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 2)
                    this.state = 188
                    javascriptAction()

                }Tokens.ACT_SCOPE_PARAMS -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 3)
                    this.state = 189
                    match(Tokens.ACT_SCOPE_PARAMS)

                }
                else -> throw NoViableAltException(this)
            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class ShellActionContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.ShellAction

        public fun ActionTemplate_BEGIN(): TerminalNode = getToken(Tokens.ActionTemplate_BEGIN, 0)!!
        public fun ActionTemplate_CLOSE(): TerminalNode = getToken(Tokens.ActionTemplate_CLOSE, 0)!!
        public fun actionTemplateEntry(): List<ActionTemplateEntryContext> = getRuleContexts(ActionTemplateEntryContext::class)
        public fun actionTemplateEntry(i: Int): ActionTemplateEntryContext? = getRuleContext(ActionTemplateEntryContext::class, i)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun shellAction(): ShellActionContext {
        var _localctx = ShellActionContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 32, Rules.ShellAction)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 192
            match(Tokens.ActionTemplate_BEGIN)

            this.state = 196
            errorHandler.sync(this)
            _la = _input.LA(1)

            while ((((_la) and 0x3f.inv()) == 0 && ((1L shl _la) and 12094627905536L) != 0L)) {
                this.state = 193
                actionTemplateEntry()

                this.state = 198
                errorHandler.sync(this)
                _la = _input.LA(1)
            }
            this.state = 199
            match(Tokens.ActionTemplate_CLOSE)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class JavascriptActionContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.JavascriptAction

        public fun CustomScript_JS_BEGIN(): TerminalNode = getToken(Tokens.CustomScript_JS_BEGIN, 0)!!
        public fun CustomScript_END(): TerminalNode = getToken(Tokens.CustomScript_END, 0)!!
        public fun CustomScript_SCRIPT(): List<TerminalNode> = getTokens(Tokens.CustomScript_SCRIPT)
        public fun CustomScript_SCRIPT(i: Int): TerminalNode? = getToken(Tokens.CustomScript_SCRIPT, i)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun javascriptAction(): JavascriptActionContext {
        var _localctx = JavascriptActionContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 34, Rules.JavascriptAction)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 201
            match(Tokens.CustomScript_JS_BEGIN)

            this.state = 205
            errorHandler.sync(this)
            _la = _input.LA(1)

            while (_la == Tokens.CustomScript_SCRIPT) {
                this.state = 202
                match(Tokens.CustomScript_SCRIPT)

                this.state = 207
                errorHandler.sync(this)
                _la = _input.LA(1)
            }
            this.state = 208
            match(Tokens.CustomScript_END)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class ConstDefContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.ConstDef

        public fun CONST(): TerminalNode = getToken(Tokens.CONST, 0)!!
        public fun IDENTIFIER(): TerminalNode = getToken(Tokens.IDENTIFIER, 0)!!
        public fun EQ(): TerminalNode = getToken(Tokens.EQ, 0)!!
        public fun literal(): LiteralContext = getRuleContext(LiteralContext::class, 0)!!

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun constDef(): ConstDefContext {
        var _localctx = ConstDefContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 36, Rules.ConstDef)

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 210
            match(Tokens.CONST)

            this.state = 211
            match(Tokens.IDENTIFIER)

            this.state = 212
            match(Tokens.EQ)

            this.state = 213
            literal()

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class LiteralContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.Literal

        public fun stringTemplate(): StringTemplateContext? = getRuleContext(StringTemplateContext::class, 0)
        public fun booleanLiteral(): BooleanLiteralContext? = getRuleContext(BooleanLiteralContext::class, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun literal(): LiteralContext {
        var _localctx = LiteralContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 38, Rules.Literal)

        try {
            this.state = 217
            errorHandler.sync(this)

            when (_input.LA(1)) {
                Tokens.DOUBLE_QUOTE -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 1)
                    this.state = 215
                    stringTemplate()

                }Tokens.TRUE, Tokens.FALSE -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 2)
                    this.state = 216
                    booleanLiteral()

                }
                else -> throw NoViableAltException(this)
            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class BooleanLiteralContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.BooleanLiteral

        public fun TRUE(): TerminalNode? = getToken(Tokens.TRUE, 0)
        public fun FALSE(): TerminalNode? = getToken(Tokens.FALSE, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun booleanLiteral(): BooleanLiteralContext {
        var _localctx = BooleanLiteralContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 40, Rules.BooleanLiteral)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 219
            _la = _input.LA(1)

            if (!(_la == Tokens.TRUE || _la == Tokens.FALSE)) {
                errorHandler.recoverInline(this)
            }
            else {
                if (_input.LA(1) == Tokens.EOF) {
                    isMatchedEOF = true
                }

                errorHandler.reportMatch(this)
                consume()
            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class StringTemplateContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.StringTemplate

        public fun DOUBLE_QUOTE(): TerminalNode = getToken(Tokens.DOUBLE_QUOTE, 0)!!
        public fun StringTemplate_CLOSE(): TerminalNode = getToken(Tokens.StringTemplate_CLOSE, 0)!!
        public fun stringTemplateEntry(): List<StringTemplateEntryContext> = getRuleContexts(StringTemplateEntryContext::class)
        public fun stringTemplateEntry(i: Int): StringTemplateEntryContext? = getRuleContext(StringTemplateEntryContext::class, i)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun stringTemplate(): StringTemplateContext {
        var _localctx = StringTemplateContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 42, Rules.StringTemplate)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 221
            match(Tokens.DOUBLE_QUOTE)

            this.state = 225
            errorHandler.sync(this)
            _la = _input.LA(1)

            while ((((_la) and 0x3f.inv()) == 0 && ((1L shl _la) and 481036337152L) != 0L)) {
                this.state = 222
                stringTemplateEntry()

                this.state = 227
                errorHandler.sync(this)
                _la = _input.LA(1)
            }
            this.state = 228
            match(Tokens.StringTemplate_CLOSE)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class StringTemplateEntryContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.StringTemplateEntry

        public fun stringTemplateContent(): StringTemplateContentContext? = getRuleContext(StringTemplateContentContext::class, 0)
        public fun stringTemplateInterpolation(): StringTemplateInterpolationContext? = getRuleContext(StringTemplateInterpolationContext::class, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun stringTemplateEntry(): StringTemplateEntryContext {
        var _localctx = StringTemplateEntryContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 44, Rules.StringTemplateEntry)

        try {
            this.state = 232
            errorHandler.sync(this)

            when (_input.LA(1)) {
                Tokens.StringTemplate_AT, Tokens.StringTemplate_CONTENT -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 1)
                    this.state = 230
                    stringTemplateContent()

                }Tokens.StringTemplate_Interpolation_OPEN -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 2)
                    this.state = 231
                    stringTemplateInterpolation()

                }
                else -> throw NoViableAltException(this)
            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class StringTemplateContentContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.StringTemplateContent

        public fun StringTemplate_CONTENT(): TerminalNode? = getToken(Tokens.StringTemplate_CONTENT, 0)
        public fun StringTemplate_AT(): TerminalNode? = getToken(Tokens.StringTemplate_AT, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun stringTemplateContent(): StringTemplateContentContext {
        var _localctx = StringTemplateContentContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 46, Rules.StringTemplateContent)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 234
            _la = _input.LA(1)

            if (!(_la == Tokens.StringTemplate_AT || _la == Tokens.StringTemplate_CONTENT)) {
                errorHandler.recoverInline(this)
            }
            else {
                if (_input.LA(1) == Tokens.EOF) {
                    isMatchedEOF = true
                }

                errorHandler.reportMatch(this)
                consume()
            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class StringTemplateInterpolationContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.StringTemplateInterpolation

        public fun StringTemplate_Interpolation_OPEN(): TerminalNode = getToken(Tokens.StringTemplate_Interpolation_OPEN, 0)!!
        public fun Interpolation_IDENTIFIER(): TerminalNode = getToken(Tokens.Interpolation_IDENTIFIER, 0)!!
        public fun Interpolation_CLOSE(): TerminalNode = getToken(Tokens.Interpolation_CLOSE, 0)!!
        public fun Interpolation_NEGATE(): TerminalNode? = getToken(Tokens.Interpolation_NEGATE, 0)
        public fun mapping(): MappingContext? = getRuleContext(MappingContext::class, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun stringTemplateInterpolation(): StringTemplateInterpolationContext {
        var _localctx = StringTemplateInterpolationContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 48, Rules.StringTemplateInterpolation)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 236
            match(Tokens.StringTemplate_Interpolation_OPEN)

            this.state = 238
            errorHandler.sync(this)
            _la = _input.LA(1)

            if (_la == Tokens.Interpolation_NEGATE) {
                this.state = 237
                match(Tokens.Interpolation_NEGATE)

            }
            this.state = 240
            match(Tokens.Interpolation_IDENTIFIER)

            this.state = 242
            errorHandler.sync(this)
            _la = _input.LA(1)

            if (_la == Tokens.Interpolation_QMARK) {
                this.state = 241
                mapping()

            }
            this.state = 244
            match(Tokens.Interpolation_CLOSE)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class ActionTemplateEntryContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.ActionTemplateEntry

        public fun actionTemplateContent(): ActionTemplateContentContext? = getRuleContext(ActionTemplateContentContext::class, 0)
        public fun actionTemplateInterpolation(): ActionTemplateInterpolationContext? = getRuleContext(ActionTemplateInterpolationContext::class, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun actionTemplateEntry(): ActionTemplateEntryContext {
        var _localctx = ActionTemplateEntryContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 50, Rules.ActionTemplateEntry)

        try {
            this.state = 248
            errorHandler.sync(this)

            when (_input.LA(1)) {
                Tokens.ActionTemplate_AT, Tokens.ActionTemplate_CONTENT -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 1)
                    this.state = 246
                    actionTemplateContent()

                }Tokens.ActionTemplate_Interpolation_OPEN -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 2)
                    this.state = 247
                    actionTemplateInterpolation()

                }
                else -> throw NoViableAltException(this)
            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class ActionTemplateContentContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.ActionTemplateContent

        public fun ActionTemplate_CONTENT(): TerminalNode? = getToken(Tokens.ActionTemplate_CONTENT, 0)
        public fun ActionTemplate_AT(): TerminalNode? = getToken(Tokens.ActionTemplate_AT, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun actionTemplateContent(): ActionTemplateContentContext {
        var _localctx = ActionTemplateContentContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 52, Rules.ActionTemplateContent)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 250
            _la = _input.LA(1)

            if (!(_la == Tokens.ActionTemplate_AT || _la == Tokens.ActionTemplate_CONTENT)) {
                errorHandler.recoverInline(this)
            }
            else {
                if (_input.LA(1) == Tokens.EOF) {
                    isMatchedEOF = true
                }

                errorHandler.reportMatch(this)
                consume()
            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class ActionTemplateInterpolationContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.ActionTemplateInterpolation

        public fun ActionTemplate_Interpolation_OPEN(): TerminalNode = getToken(Tokens.ActionTemplate_Interpolation_OPEN, 0)!!
        public fun Interpolation_IDENTIFIER(): TerminalNode = getToken(Tokens.Interpolation_IDENTIFIER, 0)!!
        public fun Interpolation_CLOSE(): TerminalNode = getToken(Tokens.Interpolation_CLOSE, 0)!!
        public fun Interpolation_NEGATE(): TerminalNode? = getToken(Tokens.Interpolation_NEGATE, 0)
        public fun mapping(): MappingContext? = getRuleContext(MappingContext::class, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun actionTemplateInterpolation(): ActionTemplateInterpolationContext {
        var _localctx = ActionTemplateInterpolationContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 54, Rules.ActionTemplateInterpolation)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 252
            match(Tokens.ActionTemplate_Interpolation_OPEN)

            this.state = 254
            errorHandler.sync(this)
            _la = _input.LA(1)

            if (_la == Tokens.Interpolation_NEGATE) {
                this.state = 253
                match(Tokens.Interpolation_NEGATE)

            }
            this.state = 256
            match(Tokens.Interpolation_IDENTIFIER)

            this.state = 258
            errorHandler.sync(this)
            _la = _input.LA(1)

            if (_la == Tokens.Interpolation_QMARK) {
                this.state = 257
                mapping()

            }
            this.state = 260
            match(Tokens.Interpolation_CLOSE)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class MappingContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.Mapping

        public fun Interpolation_QMARK(): TerminalNode = getToken(Tokens.Interpolation_QMARK, 0)!!
        public fun Interpolation_MAPPING_OPEN(): TerminalNode = getToken(Tokens.Interpolation_MAPPING_OPEN, 0)!!
        public fun MappingTemplate_CLOSE(): TerminalNode = getToken(Tokens.MappingTemplate_CLOSE, 0)!!
        public fun mappingTemplateEntry(): List<MappingTemplateEntryContext> = getRuleContexts(MappingTemplateEntryContext::class)
        public fun mappingTemplateEntry(i: Int): MappingTemplateEntryContext? = getRuleContext(MappingTemplateEntryContext::class, i)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun mapping(): MappingContext {
        var _localctx = MappingContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 56, Rules.Mapping)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 262
            match(Tokens.Interpolation_QMARK)

            this.state = 263
            match(Tokens.Interpolation_MAPPING_OPEN)

            this.state = 267
            errorHandler.sync(this)
            _la = _input.LA(1)

            while ((((_la) and 0x3f.inv()) == 0 && ((1L shl _la) and 7881299347898368L) != 0L)) {
                this.state = 264
                mappingTemplateEntry()

                this.state = 269
                errorHandler.sync(this)
                _la = _input.LA(1)
            }
            this.state = 270
            match(Tokens.MappingTemplate_CLOSE)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class MappingTemplateEntryContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.MappingTemplateEntry

        public fun MappingTemplate_CONTENT(): TerminalNode? = getToken(Tokens.MappingTemplate_CONTENT, 0)
        public fun MappingTemplate_LCURLY(): TerminalNode? = getToken(Tokens.MappingTemplate_LCURLY, 0)
        public fun MappingTemplate_PLACEHOLDER(): TerminalNode? = getToken(Tokens.MappingTemplate_PLACEHOLDER, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun mappingTemplateEntry(): MappingTemplateEntryContext {
        var _localctx = MappingTemplateEntryContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 58, Rules.MappingTemplateEntry)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 272
            _la = _input.LA(1)

            if (!((((_la) and 0x3f.inv()) == 0 && ((1L shl _la) and 7881299347898368L) != 0L))) {
                errorHandler.recoverInline(this)
            }
            else {
                if (_input.LA(1) == Tokens.EOF) {
                    isMatchedEOF = true
                }

                errorHandler.reportMatch(this)
                consume()
            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class DocstringContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.Docstring

        public fun Docstring_BEGIN(): TerminalNode = getToken(Tokens.Docstring_BEGIN, 0)!!
        public fun Docstring_END(): TerminalNode = getToken(Tokens.Docstring_END, 0)!!
        public fun docstringEntry(): List<DocstringEntryContext> = getRuleContexts(DocstringEntryContext::class)
        public fun docstringEntry(i: Int): DocstringEntryContext? = getRuleContext(DocstringEntryContext::class, i)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun docstring(): DocstringContext {
        var _localctx = DocstringContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 60, Rules.Docstring)
        var _la: Int

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 274
            match(Tokens.Docstring_BEGIN)

            this.state = 278
            errorHandler.sync(this)
            _la = _input.LA(1)

            while (_la == Tokens.Docstring_AT_PARAM || _la == Tokens.Docstring_CONTENT) {
                this.state = 275
                docstringEntry()

                this.state = 280
                errorHandler.sync(this)
                _la = _input.LA(1)
            }
            this.state = 281
            match(Tokens.Docstring_END)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class DocstringEntryContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.DocstringEntry

        public fun Docstring_CONTENT(): TerminalNode? = getToken(Tokens.Docstring_CONTENT, 0)
        public fun paramTag(): ParamTagContext? = getRuleContext(ParamTagContext::class, 0)

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun docstringEntry(): DocstringEntryContext {
        var _localctx = DocstringEntryContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 62, Rules.DocstringEntry)

        try {
            this.state = 285
            errorHandler.sync(this)

            when (_input.LA(1)) {
                Tokens.Docstring_CONTENT -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 1)
                    this.state = 283
                    match(Tokens.Docstring_CONTENT)

                }Tokens.Docstring_AT_PARAM -> /*LL1AltBlock*/ {
                    enterOuterAlt(_localctx, 2)
                    this.state = 284
                    paramTag()

                }
                else -> throw NoViableAltException(this)
            }
        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }

    public open class ParamTagContext : ParserRuleContext {
        override val ruleIndex: Int = Rules.ParamTag

        public fun Docstring_AT_PARAM(): TerminalNode = getToken(Tokens.Docstring_AT_PARAM, 0)!!
        public fun Docstring_IDENTIFIER(): TerminalNode = getToken(Tokens.Docstring_IDENTIFIER, 0)!!

        public constructor(parent: ParserRuleContext?, invokingState: Int) : super(parent, invokingState) {
        }

    }


    public fun paramTag(): ParamTagContext {
        var _localctx = ParamTagContext(context, state)
        var _token: Token?
        var _ctx: RuleContext?

        enterRule(_localctx, 64, Rules.ParamTag)

        try {
            enterOuterAlt(_localctx, 1)
            this.state = 287
            match(Tokens.Docstring_AT_PARAM)

            this.state = 288
            match(Tokens.Docstring_IDENTIFIER)

        }
        catch (re: RecognitionException) {
            _localctx.exception = re
            errorHandler.reportError(this, re)
            errorHandler.recover(this, re)
        }
        finally {
            exitRule()
        }

        return _localctx
    }
}
